import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { event: String, eventId: String, amount: Number, currency: String }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    window.sendAnalyticsEvent("premium_signup_complete")
    if (this.hasEventIdValue) {
      if (typeof window.fbq === "function") {
        window.fbq("track", this.eventValue, {
          value: this.amountValue,
          currency: this.currencyValue
        }, { eventID: this.eventIdValue })
      } else {
        console.warn("fbq not initialized for Purchase event tracking.")
      }
    }
    this.element.remove()
  }
}
